import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { UncontrolledInput } from './uncontrolled';
import { getCurrencySymbol } from '../../../utils/currency';
import { cn } from '../../../utils';
export const PriceInput = forwardRef(({ currency, className, ...props }, ref) => {
    const currencySymbol = currency ? getCurrencySymbol(currency) : '';
    if (!currency || !currencySymbol) {
        return (_jsx(UncontrolledInput, { ...props, ref: ref, type: "number", className: className }));
    }
    return (_jsxs("div", { className: cn('relative flex rounded-surface border border-border overflow-hidden', 'focus-within:outline focus-within:outline-2 focus-within:outline-border-focus focus-within:outline-offset-2', {
            'border-danger focus-within:outline-danger': props.error,
        }, className), children: [_jsx("div", { className: cn('flex items-center px-stack text-body-sm text-fg-disabled bg-bg-subtle/50 border-r border-border', {
                    'text-danger/60 bg-danger-subtle/30 border-danger-ring': props.error,
                }), children: currencySymbol }), _jsx("input", { ...props, ref: ref, type: "number", id: props.name, name: props.name, className: cn('flex-1', 'px-stack min-h-12 text-body-sm text-fg-muted', 'placeholder:text-body-sm placeholder:text-fg-disabled', '[appearance:textfield]', '[&::-webkit-outer-spin-button]:appearance-none', '[&::-webkit-inner-spin-button]:appearance-none', 'focus:outline-none', 'border-0', {
                    'text-danger placeholder:text-danger/60': props.error,
                    'cursor-not-allowed': props.disabled,
                }) })] }));
});
PriceInput.displayName = 'PriceInput';
